import templateUrl from './search-box.html';

export const searchBoxComponent = {
    bindings: {
        onSearch: '&',
        placeholder: '@'
    },

    templateUrl,

    controller: class SearchBoxComponent {
        $onInit() {
            this.searchKey = ''
        }

        _onSearch() {
            this.onSearch({
                $event: this.searchKey
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/search-box/search-box.component.js